import React from "react";

import { clearRemoteSession } from "../../context/RemoteLaunchContext";

/**
 * Safety screen for the iframe launch flow, rendered after pt:gameComplete
 * fires — in case the parent page is slow to remove the frame, or never does.
 * See docs/remote-game-launch-plan.md §5.4.
 *
 * The standalone web flow (/go/<slug>) deliberately never reaches this route.
 * Whatever ended a web session has already told the player why, in a modal they
 * had to dismiss to get here, so a page repeating it is pure friction — those
 * sessions redirect to the venue's return URL instead. See exitGame().
 */
class RemoteCompleteScreen extends React.Component {
    componentDidMount(){
        // Clean up so a stray reload doesn't reuse the dead session.
        clearRemoteSession();
        try { sessionStorage.removeItem("auth"); } catch (e) { /* ignore */ }
    }

    render(){
        return (
            <div style={{
                fontFamily: "-apple-system, system-ui, sans-serif",
                background: "#111", color: "#eee",
                display: "flex", alignItems: "center", justifyContent: "center",
                minHeight: "100vh", margin: 0, padding: "1.5rem",
                boxSizing: "border-box", textAlign: "center"
            }}>
                <div style={{ maxWidth: "28rem" }}>
                    <h1 style={{ fontSize: "1.5rem", margin: "0 0 0.75rem" }}>Game Complete</h1>
                    <p style={{ margin: 0, opacity: 0.85, lineHeight: 1.5 }}>You may close this window.</p>
                </div>
            </div>
        );
    }
}

export default RemoteCompleteScreen;
